import { render } from "./PolteqButton.vue?vue&type=template&id=28e6ca92&ts=true"
import script from "./PolteqButton.ts?vue&type=script&lang=ts&external"
export * from "./PolteqButton.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__